import { toNumber } from 'lodash';

export const parseNumbersFromString = (s: string) => toNumber(s.replace(/[^\d.-]/g, ''));
